<section class="fullHeight flex sec bg">
    <div class="pad  fullWidth">
        <div class="flex">
            <div class="flex">
                <p class="fs">Get Travel Insurance</p>
                <p class="fs">in minutes...</p>
                <h2 class="fs" style="color: var(--primary-color);">it's that Simple</h2>
            </div>
            <div style="flex: 1;" class="flex">

                <div style="flex-direction: column;" class="formCar flex">
                    <h4>Welcome🖐</h4>
                    <div>
                        <p>Sign up to get started</p>
                    </div>
                    <br>
                    <form [formGroup]="signUpForm" class="flex" style="flex-direction: column;height:100%;">
                        

                        <!-- <mat-form-field >
                            <mat-label>Last Name</mat-label>
                            <input type="text" formControlName="lname" matInput>
                        </mat-form-field> -->

                        <!-- <mat-form-field >
                            <mat-label> Contact</mat-label>
                            <input type="tel" formControlName="contact" matInput>
                        </mat-form-field> -->
                        <mat-form-field>
                            <mat-label> Email</mat-label>
                            <input type="email" [email]="true" formControlName="email" matInput>
                            <mat-error *ngIf="signUpForm.get('email')?.errors?.['email']">
                                email address is not valid. </mat-error>
                        </mat-form-field>

                        <!-- <mat-form-field >
                            <mat-label> Set Password</mat-label>
                            <input  [type]="hide ? 'password' : 'text'"formControlName="pwd" matInput>
                        </mat-form-field> -->

                        <div style="position: relative;">

                            <mat-form-field>
                                <mat-label> set password</mat-label>
                                <input [type]="hide ? 'password' : 'text'" #pwd formControlName="password" matInput>
                            </mat-form-field>
                            <mat-icon style="    margin-left: -35px;" class="eye" (click)="eye()">
                                {{hide ? 'visibility_off' : 'visibility'}}
                            </mat-icon>

                        </div>
                        <div style="position: relative;">

                            <mat-form-field>
                                <mat-label> confirm password</mat-label>
                                <input [type]="hide1 ? 'password' : 'text'" #cpwd formControlName="cpwd" matInput>
                            </mat-form-field>
                            <mat-icon style="    margin-left: -35px;" class="eye" (click)="eye1()">
                                {{hide1 ? 'visibility_off' : 'visibility'}}
                            </mat-icon>
                            <div *ngIf="cpwd.value.length >3">

                                <mat-error *ngIf=" pwd.value != cpwd.value ">Password Mismatch</mat-error>
                            </div>
                        </div>
                        <mat-form-field>
                            <mat-label>Register As</mat-label>
                            <mat-select formControlName="role">
                                <!-- <mat-option value="staff">Heirs Staff</mat-option> -->
                                <mat-option value="agency">Travel Agent</mat-option>
                                <mat-option value="broker">Broker</mat-option>
                            </mat-select>
                          </mat-form-field>
                        <mat-form-field *ngIf="referredBy">
                            <mat-label> Referered By</mat-label>
                            <input formControlName="referred_by" readonly matInput>
                        </mat-form-field>
                        <button type="button" [disabled]="!signUpForm.valid" style="width: 100%;" color="accent" (click)="signUp()"
                            mat-flat-button>Register</button>
                    </form>
                    <br>
                    <div class="flex">
                        <p>Have an Account? &nbsp;</p>
                        <a routerLink="/signin" style="color: var(--primary-color);">Sign In</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>